const SUPPORTED_ITALIC_FONT_STYLES = ['oblique', 'italic'];

const hasItalicStyle = (element) => {
  const { fontStyle } = element.style;

  return SUPPORTED_ITALIC_FONT_STYLES.includes(fontStyle);
};

export default hasItalicStyle;
